<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-12-12 15:31:44
 * @LastEditTime: 2026-06-09 14:59:19
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 对接订单
 * @FilePath: \ICPSxin\src\views\platform\ICPS\smart\schedul\dockPlan.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">工程名称</span>
                  <el-input v-model="tableParam.projectName" style="width: 240px" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">状态</span>
                  <el-select v-model="tableParam.bindingStatus" placeholder="请选择" clearable>
                    <el-option :key="0" label="未确定" :value="0"> </el-option>
                    <el-option :key="1" label="已确定" :value="1"> </el-option>
                    <el-option :key="2" label="已取消" :value="3"> </el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">浇筑时间</span>
                  <el-date-picker v-model="startTimDateEndTimDate" type="datetimerange" unlink-panels
                    value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"
                    @change="(tableParam.startTime = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.endTime = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"></el-date-picker>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all"
                  @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
                <el-button size="medium" class="bottom_two" style="margin-left: 12px"
                  @click="canclePlan()">取消订单</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" :selectable="selectable"> </el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '状态'">{{ ["未确认", "已确认", "", "已取消"][scope.row[item.prop]] }}</span>
                      <div v-else-if="item.label == '操作'">
                        <el-button v-if="scope.row.bindingStatus == 0" size="mini" class="bottom_one"
                          @click="confirm(scope.row, '对接订单审批', false)">确认</el-button>
                        <el-button v-else size="mini" class="bottom_one"
                          @click="confirm(scope.row, '对接订单查看', true)">查看</el-button>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
      <!-- 添加 -->
      <el-dialog v-dialogDrag :visible.sync="addDialog" width="1400px" height="1320px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
        <div class="dialoginfo">
          <el-row>
            <el-col :span="6">
              <el-card class="box-card">
                <el-form ref="reffromData2" :inline="true" :model="formData.externalPlan" label-width="130px">
                  <el-form-item>
                    <span slot="label">项目名称</span>
                    <span style="width: 150px">{{ formData.externalPlan.projectName }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">项目组织名称</span>
                    <span style="width: 150px">{{ formData.externalPlan.projectCompanyName }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">对接系统订单ID</span>
                    <span style="width: 150px">{{ formData.externalPlan.id }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">对接系统订单编号</span>
                    <span style="width: 150px">{{ formData.externalPlan.orderCode }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">订单方量</span>
                    <span style="width: 150px">{{ formData.externalPlan.orderQuantity ?
                      Number(formData.externalPlan.orderQuantity).toFixed(4) : "" }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">订单类型</span>
                    <span style="width: 150px">{{ formData.externalPlan.orderType == 10 ? "商砼" : "砂浆" }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">规格型号</span>
                    <span style="width: 150px">{{ formData.externalPlan.materialType }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">抗渗等级</span>
                    <span style="width: 150px">{{ formData.externalPlan.impermeabilityGrade || "" }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">抗冻等级</span>
                    <span style="width: 150px">{{ formData.externalPlan.antifreezeGrade || "" }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">抗折等级</span>
                    <span style="width: 150px">{{ formData.externalPlan.bendingGrade || "" }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">特殊类型</span>
                    <span style="width: 150px">{{ formData.externalPlan.admixtureCombination || "" }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">塌落度</span>
                    <span style="width: 150px">{{ formData.externalPlan.slumps }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">浇筑方式</span>
                    <span v-if="formData.externalPlan.pouringType == 10" style="width: 150px">自卸</span>
                    <span v-else-if="formData.externalPlan.pouringType == 20" style="width: 150px">车泵</span>
                    <span v-else-if="formData.externalPlan.pouringType == 30" style="width: 150px">地泵</span>
                    <span v-else-if="formData.externalPlan.pouringType == 40" style="width: 150px">喷射</span>
                    <span v-else style="width: 150px"></span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">泵送高度</span>
                    <span style="width: 150px">{{ formData.externalPlan.pumpTruckHeight }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">浇筑部位</span>
                    <span style="width: 150px">{{ formData.externalPlan.pourSite }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">预计使用时间</span>
                    <span style="width: 150px">{{ formData.externalPlan.planTime }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">厂站名称</span>
                    <span style="width: 150px">{{ formData.externalPlan.station }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">收货地址</span>
                    <span style="width: 150px">{{ formData.externalPlan.projectAddress }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">经度</span>
                    <span style="width: 150px">{{ formData.externalPlan.projectLongitude }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">纬度</span>
                    <span style="width: 150px">{{ formData.externalPlan.projectLatitude }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">收货人</span>
                    <span style="width: 150px">{{ formData.externalPlan.placer }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">收货人电话</span>
                    <span style="width: 150px">{{ formData.externalPlan.placerPhone }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">下单时间</span>
                    <span style="width: 150px">{{ formData.externalPlan.createTime }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">备注</span>
                    <span style="width: 150px">{{ formData.externalPlan.memo }}</span>
                  </el-form-item>
                </el-form>
              </el-card>
            </el-col>
            <el-col :span="17" :offset="1">
              <el-card class="box-card">
                <el-form ref="reffromData" :rules="rules" :inline="true" :model="formData.insidePlan" label-width="110px">
                  <el-form-item prop="engineeringName">
                    <span slot="label">工程名称</span>
                    <el-select v-model="formData.insidePlan.engineeringName" :disabled="buttonType" filterable
                      allow-create default-first-option placeholder="请选择">
                      <el-option v-for="item in engineeringNameList" :key="item.id" :label="item.name" :value="item.name"
                        @click.native="selectEngineeringName(item)"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="structuralParts">
                    <span slot="label">浇筑部位</span>
                    <el-select v-model="formData.insidePlan.structuralParts" :disabled="buttonType" filterable
                      allow-create default-first-option placeholder="请选择" @change="structuralPartsCheckFun()">
                      <el-option v-for="item in structuralPartsList" :key="item.id"
                        :label="item.structuralParts + (item.used == 1 ? '-已选择' : '-未选择')" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="strengthGradeId" label="强度等级">
                    <el-select v-model="formData.insidePlan.strengthGradeId" :disabled="buttonType" placeholder="请选择"
                      filterable>
                      <el-option v-for="item in strengthGradeList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">性能等级</span>
                    <el-select v-model="formData.insidePlan.performanceGradeIdList" :disabled="buttonType" multiple
                      placeholder="请选择" filterable>
                      <el-option v-for="item in performanceGradeList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">材料要求</span>
                    <el-select v-model="formData.insidePlan.meterialRequirementsIdList" :disabled="buttonType" multiple
                      placeholder="请选择" filterable>
                      <el-option v-for="item in meterialRequirementsList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">特殊要求</span>
                    <el-select v-model="formData.insidePlan.specialRequirementsIdList" :disabled="buttonType" multiple
                      placeholder="请选择" filterable>
                      <el-option v-for="item in specialRequirementsList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">其他要求</span>
                    <el-select v-model="formData.insidePlan.otherRequirementsIdList" :disabled="buttonType" multiple
                      placeholder="请选择" filterable>
                      <el-option v-for="item in otherRequirementsList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">外加剂要求</span>
                    <el-select v-model="formData.insidePlan.admixtureRequirementsIdList" :disabled="buttonType" multiple
                      placeholder="请选择" filterable>
                      <el-option v-for="item in admixtureRequirementsList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="pouringMethodIdList">
                    <span slot="label">浇筑方式</span>
                    <el-select v-model="formData.insidePlan.pouringMethodIdList" :disabled="buttonType" multiple
                      placeholder="请选择">
                      <el-option v-for="item in pouringMethodList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">坍落度</span>
                    <el-select v-model="formData.insidePlan.slump" :disabled="buttonType" placeholder="请选择" filterable
                      @change="slumpChange">
                      <el-option v-for="item in slumpArr" :key="item.id" :label="item.itemName"
                        :value="item.itemName"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="pouringTime">
                    <span slot="label">浇筑时间</span>
                    <el-date-picker v-model="formData.insidePlan.pouringTime" :disabled="buttonType" type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" :picker-options="{
                        step: '10:00',
                      }"></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">是否超高层</span>
                    <el-select v-model="formData.insidePlan.supperHighLayer" :disabled="buttonType" placeholder="请选择"
                      filterable @change="typeChange">
                      <el-option v-for="item in supperHighLayerList" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">泵送高度</span>
                    <el-input v-model="formData.insidePlan.pouringHigh" :disabled="buttonType" placeholder="请输入">
                      <span slot="suffix">米</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="pouringNum">
                    <span slot="label">浇筑用量</span>
                    <el-input v-model="formData.insidePlan.pouringNum"
                      v-input-limit="value => (String(value || '').match(/\d{1,8}(\.\d{1}|\.)?/) ? String(value || '').match(/\d{1,8}(\.\d{1}|\.)?/)[0] : '')"
                      :disabled="buttonType" placeholder="请输入">
                      <span slot="suffix"> m³</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="person">
                    <span slot="label">联系人</span>
                    <el-input v-model="formData.insidePlan.person" :disabled="buttonType" placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-form-item prop="phoneNum">
                    <span slot="label">联系电话</span>
                    <el-input v-model="formData.insidePlan.phoneNum" :disabled="buttonType" type="Number"
                      placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-form-item prop="structureSize">
                    <span slot="label">订单备注</span>
                    <el-input v-model="formData.insidePlan.orderRemark" :disabled="buttonType" :rows="5" resize="none"
                      style="width: 760px" type="textarea" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                  <el-form-item prop="pointId">
                    <span slot="label">供应站点</span>
                    <el-select ref="addpoint" v-model="formData.insidePlan.pointId" :disabled="buttonType"
                      placeholder="请选择" @change="
                        $forceUpdate();
                      $nextTick(() => {
                        formData.insidePlan.pointName = $refs.addpoint.selectedLabel;
                      });
                      choiseBussinessPoint(true);
                      ">
                      <el-option v-for="(v, k) in sitelist" :key="k" :label="v.name" :value="v.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="settleId">
                    <span slot="label">结算方式</span>
                    <el-select ref="addsettle" v-model="formData.insidePlan.settleId" :disabled="buttonType"
                      placeholder="请选择" @change="
                        $forceUpdate();
                      $nextTick(() => {
                        formData.insidePlan.settleName = $refs.addsettle.selectedLabel;
                      });
                      ">
                      <el-option label="双控" value="0"></el-option>
                      <el-option label="图结" value="1"></el-option>
                      <el-option label="实结" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="formData.insidePlan.settleId != '2'" prop="graphicNum">
                    <span slot="label">图算量</span>
                    <el-input v-model="formData.insidePlan.graphicNum" :disabled="buttonType" placeholder="请输入">
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">富余量</span>
                    <el-select ref="addlossNum" v-model="formData.insidePlan.lossNumId" :disabled="buttonType"
                      placeholder="请选择" @change="
                        $forceUpdate();
                      $nextTick(() => {
                        formData.insidePlan.lossNum = $refs.addlossNum.selectedLabel;
                      });
                      ">
                      <el-option v-for="(v, k) in marginNumberList" :key="k" :label="v.itemName"
                        :value="v.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">增值服务项</span>
                    <div style="width: 660px; height: 36px">{{ servicePoint }}</div>
                  </el-form-item>
                  <el-form-item>
                    <el-button v-if="!buttonType" class="bottom_two" @click="choiseBussinessPoint()">更改</el-button>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">内部备注</span>
                    <el-input v-model="formData.insidePlan.remark" :disabled="buttonType" :rows="1" resize="none"
                      style="width: 760px" type="textarea" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-form>
              </el-card>
              <el-card v-if="controlForm.controlStatus == 1" class="box-card">
                <soan style="color:red">{{ controlForm.controlStatusHint }}</soan>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="addDialog = false">取 消</el-button>
          <el-button v-if="!buttonType" class="bottom_all" :disabled="saveing || controlForm.controlStatus == 1"
            style="margin-left: 24px" @click="submit()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 管控业务点 -->
      <el-dialog v-dialogDrag :visible.sync="bussinessVisible" width="60%">
        <span slot="title" class="dialog-title">管控业务点</span>
        <el-checkbox-group v-model="buspointids">
          <template v-for="(item, index) in buspointArr">
            <div :key="index" class="checkbox-bg">
              <el-checkbox :label="item.id">{{ item.itemName }}</el-checkbox>
            </div>
          </template>
        </el-checkbox-group>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="bussinessVisible = false">关 闭</el-button>
          <el-button class="bottom_all" @click="handlePoint">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 含税单价 -->
      <el-dialog :visible.sync="ProductCostDig" width="1000px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">含税单价</span>
        <div class="dialoginfo">
          <span>价格类型:{{ planProductCost.productTypeNmae }}</span>
          <div style="margin-top: 10px">
            <el-table ref="multipleTable" :header-cell-style="{ background: '#f3f6f9' }"
              :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="priceTableData"
              :span-method="objectSpanMethod" tooltip-effect="dark">
              <el-table-column label="类型" align="center" prop="dataType">
                <template slot-scope="scope">
                  <span v-if="scope.row.dataType == 1">产品费用</span>
                  <span v-else-if="scope.row.dataType == 2">泵送费用</span>
                  <span v-else-if="scope.row.dataType == 3">超高层</span>
                  <span v-else>{{ scope.row.dataType }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center" prop="name">
                <template slot-scope="scope">
                  <el-popover v-if="scope.row.dataType == '特殊条款'" placement="top-start" width="400" trigger="hover"
                    :content="scope.row.name">
                    <span slot="reference" class="OverTxt">{{ scope.row.name }}</span>
                  </el-popover>
                  <span v-else>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="价格" align="center" prop="dataValue"></el-table-column>
            </el-table>
            <div v-for="(item, index) in planProductCost.errorPointOut" :key="index" style="margin-top: 10px">
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="(ProductCostDig = false), (saveing = false)">关 闭</el-button>
          <el-button :disabled="!planProductCost.surePermitSubmit" class="bottom_all" @click="submit2()">确认</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, queryExterEngineeringList, getThirdPlanDetail, saveDockingPlan, deleteExternalPlan } from "@/api/smart/schedul/dockPlan.js";
import { getUserInfo } from "@/utils/auth.js";
import { graphic_list } from "@/api/smart/schedul/b.js";
import { getDisClostDetail } from "@/api/internetSales/projectClarifi.js";
import { getDicType, getStationByCompanyId } from "@/api/common.js";
import { queryPlanProductCost } from "@/api/smart/schedul/c.js";
import { queryControlMession } from "@/api/internetSales/supplyManagement.js";
import { queryProcesses } from "@/api/basicConfig/proflow.js";
export default {
  mixins: [mixin],
  data() {
    return {
      buttonType: false,
      saveing: false,
      table: [
        // { label: "客户名称", prop: "logisticsCode", status: true,width:'220' },
        { label: "对接系统订单编号", prop: "orderCode", status: true, width: "auto" },
        { label: "对接系统工程名称", prop: "projectName", status: true, width: "auto" },
        { label: "本系统订单号", prop: "orderNo", status: true, width: "200" },
        { label: "本系统工程名称", prop: "engineeringName", status: true, width: "150" },
        { label: "浇筑部位", prop: "pourSite", status: true, width: "auto" },
        { label: "产品名称", prop: "productName", status: true },
        { label: "浇筑用量 ", prop: "orderQuantity", status: true, width: "auto" },
        { label: "浇筑时间", prop: "pourTime", status: true, width: "auto" },
        { label: "下单时间", prop: "cretePlanTime", status: true, width: "auto" },
        { label: "状态", prop: "bindingStatus", status: true, width: "auto" },
        { label: "操作", prop: "residueNum", status: true, width: "auto" },
      ],
      queryPage: queryPage,
      tableData: [],
      pagesType: 0,
      startTimDateEndTimDate: [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")],
      formData: {
        insidePlan: {
          strengthGradeId: "", //强度等级
          performanceGradeIdList: [],
          meterialRequirementsIdList: [],
          specialRequirementsIdList: [],
          otherRequirementsIdList: [],
          admixtureRequirementsIdList: [],
          pouringMethodIdList: [],
          pouringTime: "", //浇筑时间
          slump: "",
          slumpId: "",
        },
        externalPlan: {},
      },
      engineeringNameList: [],
      strengthGradeList: [], //强度list
      performanceGradeList: [], //性能等级list
      meterialRequirementsList: [], //材料要求list
      specialRequirementsList: [], //特殊要求list
      otherRequirementsList: [], //其他要求list
      admixtureRequirementsList: [], //外加剂要求list
      pouringMethodList: [], //浇筑方式list
      structuralPartsList: [], //浇筑部位
      sitelist: [],
      slumpArr: [],
      marginNumberList: [],
      buspointArr: [],
      bussinessVisible: false,
      servicePoint: "",
      buspointids: [],
      detailData: "",
      supperHighLayerList: [
        { value: 1, label: "是" },
        { value: 0, label: "否" },
      ],
      rules: {
        engineeringName: [
          {
            required: true,
            message: "请选择工程名称",
            trigger: "change",
          },
        ],
        structuralParts: [
          {
            required: true,
            message: "请输入浇筑部位",
            trigger: "change",
          },
        ],
        strengthGradeId: [{ required: true, message: "请选择强度等级", trigger: "change" }],
        pouringMethodIdList: [
          {
            required: true,
            message: "请选择浇筑方式",
            trigger: "change",
          },
        ],
        pouringNum: [{ required: true, message: "请输入浇筑用量", trigger: "change" }],
        pouringTime: [
          {
            required: true,
            message: "请选择浇筑时间",
            trigger: "change",
          },
        ],
        person: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "change",
          },
        ],
        phoneNum: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "change",
          },
          { min: 11, max: 11, message: "手机号格式错误", trigger: "change" },
        ],
      },
      ids: [],
      ProductCostDig: false,
      priceTableData: "",
      planProductCost: "",
      controlForm: {},
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.startTime = val[0];
        this.tableParam.endTime = val[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
  },
  async created() {
    this.tableParam = { ...this.tableParam, startTime: "", endTime: "", carNo: "", type: "type_outer", productionSite: "" };
    this.tableParam.startTime = this.startTimDateEndTimDate[0] || "";
    this.tableParam.endTime = this.startTimDateEndTimDate[1] || "";
    this.tableParam.productionSite = await getUserInfo()?.pointIds[0];
    this.gettableData();
    queryExterEngineeringList({ company: "third_bureau" }).then(res => {
      this.engineeringNameList = res.data;
    });
    getDicType({
      code: "slump",
    }).then(res => {
      this.slumpArr = res.data.items;
    });
    getDicType({
      code: "marginNumber",
    }).then(res => {
      this.marginNumberList = res.data.items;
    });
    // getDicType({
    //   code: "market",
    // }).then(res => {
    //   this.buspointArr = res.data.items;
    // });
  },
  methods: {
    /*设置表格禁选的行 */
    selectable(row) {
      if (row.bindingStatus !== 3) {
        return true;
      }
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(item => {
        this.ids.push(item.id);
      });
    },
    canclePlan() {
      if (this.ids.length == 0) {
        this.$message({
          message: "请选择要操作的数据项",
          type: "warning",
        });
        return;
      }
      this.$confirm("此操作将永久取消该计划?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteExternalPlan(this.ids).then(res => {
            if (res.code == 1001) {
              this.gettableData();
              this.$message({
                message: "取消成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },
    slumpChange() {
      if (this.formData.insidePlan.slump && this.slumpArr.length > 0) {
        let slumpItem = this.slumpArr.filter(item => {
          return item.itemName == this.formData.insidePlan.slump;
        });
        this.formData.insidePlan.slumpId = slumpItem[0].id;
      }
    },
    typeChange(val) {
      if (val == 0) {
        this.$set(this.rules.pouringHigh, 0, "");
      } else {
        //开启校验
        this.$set(this.rules.pouringHigh, 0, this.pouringHigh);
      }
    },
    //添加计划
    submit() {
      this.$refs.reffromData.validate(valid => {
        if (valid) {
          this.saveing = true;
          //   this.formData.insidePlan.engineeringName = this.engineeringName;
          //   this.formData.insidePlan.engineeringId = this.engineeringId;
          this.formData.insidePlan.strengthGrade = this.$fromatTable(this.strengthGradeList, this.formData.insidePlan.strengthGradeId, "id", "name");
          //性能等级-开始数据重装
          if (this.formData.insidePlan.performanceGradeIdList.length > 0) {
            let arr = [];
            this.formData.insidePlan.performanceGradeIdList.forEach(v => {
              this.performanceGradeList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formData.insidePlan.performanceGradeId = arr;
            this.formData.insidePlan.performanceGradeId = JSON.stringify(this.formData.insidePlan.performanceGradeId);
            this.formData.insidePlan.performanceGrade = this.formData.insidePlan.performanceGradeId;
          }
          //材料要求-开始数据重装
          if (this.formData.insidePlan.meterialRequirementsIdList.length > 0) {
            let arr = [];
            this.formData.insidePlan.meterialRequirementsIdList.forEach(v => {
              this.meterialRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formData.insidePlan.meterialRequirementsId = arr;
            this.formData.insidePlan.meterialRequirementsId = JSON.stringify(this.formData.insidePlan.meterialRequirementsId);
            this.formData.insidePlan.meterialRequirements = this.formData.insidePlan.meterialRequirementsId;
          }
          //特殊要求-开始数据重装
          if (this.formData.insidePlan.specialRequirementsIdList.length > 0) {
            let arr = [];
            this.formData.insidePlan.specialRequirementsIdList.forEach(v => {
              this.specialRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formData.insidePlan.specialRequirementsId = arr;
            this.formData.insidePlan.specialRequirementsId = JSON.stringify(this.formData.insidePlan.specialRequirementsId);
            this.formData.insidePlan.specialRequirements = this.formData.insidePlan.specialRequirementsId;
          }
          //其他要求-开始数据重装
          if (this.formData.insidePlan.otherRequirementsIdList.length > 0) {
            let arr = [];
            this.formData.insidePlan.otherRequirementsIdList.forEach(v => {
              this.otherRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formData.insidePlan.otherRequirementsId = arr;
            this.formData.insidePlan.otherRequirementsId = JSON.stringify(this.formData.insidePlan.otherRequirementsId);
            this.formData.insidePlan.otherRequirements = this.formData.insidePlan.otherRequirementsId;
          }
          //外加剂要求-开始数据重装
          if (this.formData.insidePlan.admixtureRequirementsIdList.length > 0) {
            let arr = [];
            this.formData.insidePlan.admixtureRequirementsIdList.forEach(v => {
              this.admixtureRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formData.insidePlan.admixtureRequirements = arr;
            this.formData.insidePlan.admixtureRequirements = JSON.stringify(this.formData.insidePlan.admixtureRequirements);
          }
          //浇筑方式-开始数据重装
          if (this.formData.insidePlan.pouringMethodIdList.length > 0) {
            let arr = [];
            this.formData.insidePlan.pouringMethodIdList.forEach(v => {
              this.pouringMethodList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                    type: v2.type,
                  });
                }
              });
            });
            this.formData.insidePlan.pouringMethod = arr;
          }
          this.formData.insidePlan.pouringMethod = JSON.stringify(this.formData.insidePlan.pouringMethod);
          this.formData.insidePlan.approvalStatus = 1;
          this.formData.insidePlan.id = this.formData.externalPlan.icpsPlanId;
          this.structuralPartsFun();
          let params = {
            strengthGradeId: this.formData.insidePlan.strengthGradeId,
            // servicePoint: this.formData.insidePlan.servicePoint,
            engineeringId: this.formData.insidePlan.engineeringId,
            strengthGrade: this.formData.insidePlan.strengthGrade,
            performanceGradeId: this.formData.insidePlan.performanceGradeId,
            performanceGrade: this.formData.insidePlan.performanceGradeId,
            meterialRequirementsId: this.formData.insidePlan.meterialRequirementsId,
            meterialRequirements: this.formData.insidePlan.meterialRequirementsId,
            specialRequirementsId: this.formData.insidePlan.specialRequirementsId,
            specialRequirements: this.formData.insidePlan.specialRequirementsId,
            otherRequirementsId: this.formData.insidePlan.otherRequirementsId,
            otherRequirements: this.formData.insidePlan.otherRequirementsId,
            admixtureRequirements: this.formData.insidePlan.admixtureRequirements,
            pouringMethod: this.formData.insidePlan.pouringMethod,
            supperHighLayer: this.formData.insidePlan.supperHighLayer,
            pouringHigh: this.formData.insidePlan.pouringHigh,
            stationId: this.formData.insidePlan.pointId,//新增站点id
          };
          queryPlanProductCost(params).then(res => {
            if (res.code == 1001) {
              this.planProductCost = res.data;
              this.priceTableData = [...res.data.productCosts, ...res.data.pumpCosts];
              let smallQuantityObj = {
                dataType: "小方量",
                name: res.data.smallQuantity,
              };
              let sprcialProvisionsObj = {
                dataType: "特殊条款",
                name: res.data.sprcialProvisions,
              };
              this.priceTableData.push(res.data.superHighs);
              this.priceTableData.push(smallQuantityObj);
              this.priceTableData.push(sprcialProvisionsObj);
              this.addOrExamine = 1;
              this.ProductCostDig = true;
            }
          });
        } else {
          return false;
        }
      });
    },
    submit2() {
      const params = {
        remark: this.formData.insidePlan.remark,
        arrangement: {
          pointId: this.formData.insidePlan.pointId,
          pointName: this.formData.insidePlan.pointName,
          settleId: this.formData.insidePlan.settleId,
          settleName: this.formData.insidePlan.settleName,
          lossNumId: this.formData.insidePlan.lossNumId,
          lossNum: this.formData.insidePlan.lossNum,
          enginnerId: this.formData.insidePlan.enginnerId,
          remark: this.formData.insidePlan.remark,
          servicePoint: this.formData.insidePlan.servicePoint,
        },
        engineeringPlan: { ...this.formData.insidePlan },
      };
      saveDockingPlan(params)
        .then(res => {
          if (res.code == 1001) {
            this.addDialog = false;
            this.saveing = false;
            this.ProductCostDig = false;
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.gettableData();
          }
        })
        .catch(() => {
          this.saveing = false;
        });
    },
    structuralPartsFun() {
      console.log(this.structuralPartsList, this.formData.insidePlan.structuralParts);
      let item = this.structuralPartsList.find(v => v.id == this.formData.insidePlan.structuralParts);
      if (item) {
        this.formData.insidePlan.structuralPartsId = this.formData.insidePlan.structuralParts;
        this.formData.insidePlan.structuralParts = item.structuralParts;
      } else {
        this.formData.insidePlan.structuralPartsId = "";
      }
    },
    // choiseBussinessPoint() {
    //   this.bussinessVisible = true;
    // },
    // handlePoint() {
    //   const newData = this.buspointArr.filter(item => this.buspointids.some(items => item.id === items));
    //   this.servicePoint = newData.map(item => item.itemName).join(",");
    //   this.formData.insidePlan.servicePoint = JSON.stringify(newData.map(item => ({ id: item.id, name: item.itemName, type: 1 })));
    //   this.bussinessVisible = false;
    // },
    choiseBussinessPoint(type) {
      const currentPointId = this.formData.insidePlan.pointId;
      if (!currentPointId && !type) {
        this.$message.warning("请选择供应站点后再进行操作");
        return;
      }
      if (!type) {
        this.bussinessVisible = true;
      }
      if (currentPointId) {
        queryProcesses({ stationId: currentPointId }).then(res => {
          if (res.code === 1001) {
            const allItems = res.data.servicePoint ? JSON.parse(res.data.servicePoint) : [];
            this.buspointArr = allItems.map(item => ({
              id: item.id,
              itemName: item.name || item.itemName
            }));

            const copyData = allItems.filter(item => item.type * 1 === 1);
            this.buspointids = copyData.map(item => item.id);
            this.servicePoint = copyData.map(item => item.name || item.itemName).join("、");
            
            this.formData.insidePlan.servicePoint = JSON.stringify(
              copyData.map(item => ({ id: item.id, name: item.name || item.itemName, type: 1 }))
            );
          }
        });
      }
    },
    handlePoint() {
      const newData = this.buspointArr.filter(item => this.buspointids.some(items => item.id === items));
      this.servicePoint = newData.map(item => item.itemName).join(",");
      this.formData.insidePlan.servicePoint = JSON.stringify(
        newData.map(item => ({ id: item.id, name: item.itemName, type: 1 }))
      );
      this.bussinessVisible = false;
    },
    selectEngineeringName(item) {
      this.formData.insidePlan.engineeringId = item.id;
      this.formData.insidePlan.companyId = item.companyId;
      graphic_list({ engineeringId: item.id }).then(res => {
        this.structuralPartsList = res.data;
      });
      this.getDisClostDisAddCostFun(item.id);
      this.setstationIdlist(item.companyId);
    },
    /*根据公司获取站点*/
    async setstationIdlist(companyId) {
      await getStationByCompanyId({ id: companyId }).then(res => {
        this.sitelist = res.data.map(v => {
          return {
            id: v.stationId,
            name: v.stationName,
          };
        });
      });
    },
    getDisClostDisAddCostFun(id) {
      getDisClostDetail({ id }).then(res => {
        if (res.code === 1001) {
          this.formData.insidePlan.pointId = res.data.mainSupplySiteId;
          this.formData.insidePlan.pointName = res.data.mainSupplySite;
          this.strengthGradeList = JSON.parse(res.data.strengthGrade);
          this.performanceGradeList = JSON.parse(res.data.performanceRate);
          //材料要求pouringMethodList
          this.meterialRequirementsList = JSON.parse(res.data.materialRequirements);
          //特殊要求
          this.specialRequirementsList = JSON.parse(res.data.specialRequirements);
          //外加剂要求
          this.admixtureRequirementsList = JSON.parse(res.data.admixtureRequirements);
          //其他要求
          this.otherRequirementsList = JSON.parse(res.data.otherRequirements);
          //浇筑方式
          this.pouringMethodList = JSON.parse(res.data.pumpType);

          this.detailData = res.data;
          this.formData.insidePlan.servicePoint = this.detailData.servicePoint; // 默认增值服务项
          this.servicePoint = JSON.parse(this.detailData.servicePoint)
            .map(item => item.name)
            .join(",");
          this.buspointids = JSON.parse(this.detailData.servicePoint).map(item => item.id);
        }
      });
    },
    look() { },
    /*修改数据打开时*/
    confirm(data, text, buttonType) {
      this.addDialog = true;
      let _this = this;
      this.buttonType = buttonType;
      setTimeout(() => {
        this.$refs.reffromData.clearValidate();
      }, 10);
      this.addDialogTitle = text;
      getThirdPlanDetail({ planId: data.id }).then(res => {
        this.formData = res.data;
        if (!res.data.insidePlan) {
          let dataCopy = Object.assign({}, data);
          let formData = {
            strengthGradeId: "", //强度等级
            performanceGradeIdList: [],
            meterialRequirementsIdList: [],
            specialRequirementsIdList: [],
            otherRequirementsIdList: [],
            admixtureRequirementsIdList: [],
            pouringMethodIdList: [],
            pouringTime: "", //浇筑时间
            slump: "",
            slumpId: "",
            engineeringName: "",
            graphicNum: "",
          };
          this.formData.insidePlan = { dataCopy, ...formData };
          //浇筑部位和浇筑用量、工程名称、联系人、联系电话、订单备注、浇筑时间取外部订单的(确认时)
          this.$set(_this.formData.insidePlan, "structuralParts", _this.formData.externalPlan.pourSite);
          this.$set(_this.formData.insidePlan, "engineeringName", data.accEngineeringName);
          this.$set(_this.formData.insidePlan, "engineeringId", data.accEngineeringId);
          this.$set(_this.formData.insidePlan, "pouringNum", _this.formData.externalPlan.orderQuantity);
          this.$set(_this.formData.insidePlan, "pouringTime", _this.formData.externalPlan.planTime);
          this.$set(_this.formData.insidePlan, "person", _this.formData.externalPlan.placer);
          this.$set(_this.formData.insidePlan, "phoneNum", _this.formData.externalPlan.placerPhone);
          this.$set(_this.formData.insidePlan, "orderRemark", _this.formData.externalPlan.memo);
        } else {
          if (this.formData.insidePlan.performanceGradeId) {
            this.$set(
              this.formData.insidePlan,
              "performanceGradeIdList",
              JSON.parse(this.formData.insidePlan.performanceGradeId).map(v => {
                return v.id;
              })
            );
          } else {
            this.formData.insidePlan.performanceGradeIdList = [];
          }
          if (this.formData.insidePlan.meterialRequirementsId) {
            this.$set(
              this.formData.insidePlan,
              "meterialRequirementsIdList",
              JSON.parse(this.formData.insidePlan.meterialRequirementsId).map(v => {
                return v.id;
              })
            );
          } else {
            this.formData.insidePlan.meterialRequirementsIdList = [];
          }
          if (this.formData.insidePlan.specialRequirementsId) {
            this.$set(
              this.formData.insidePlan,
              "specialRequirementsIdList",
              JSON.parse(this.formData.insidePlan.specialRequirementsId).map(v => {
                return v.id;
              })
            );
          } else {
            this.formData.insidePlan.specialRequirementsIdList = [];
          }
          if (this.formData.insidePlan.otherRequirementsId) {
            this.$set(
              this.formData.insidePlan,
              "otherRequirementsIdList",
              JSON.parse(this.formData.insidePlan.otherRequirementsId).map(v => {
                return v.id;
              })
            );
          } else {
            this.formData.insidePlan.otherRequirementsIdList = [];
          }
          if (this.formData.insidePlan.admixtureRequirements) {
            this.$set(
              this.formData.insidePlan,
              "admixtureRequirementsIdList",
              JSON.parse(this.formData.insidePlan.admixtureRequirements).map(v => {
                return v.id;
              })
            );
          } else {
            this.formData.insidePlan.admixtureRequirementsIdList = [];
          }
          if (this.formData.insidePlan.pouringMethod) {
            //   this.formData.insidePlan.pouringMethodIdList = JSON.parse(this.formData.insidePlan.pouringMethod).map((v) => {
            //     return v.id
            //   });
            this.$set(
              this.formData.insidePlan,
              "pouringMethodIdList",
              JSON.parse(this.formData.insidePlan.pouringMethod).map(v => {
                return v.name;
              })
            );
          } else {
            this.formData.insidePlan.pouringMethodIdList = [];
          }
        }

        let companyId = res.data.insidePlan.companyId ? res.data.insidePlan.companyId : this.engineeringNameList.find(item => item.id == data.accEngineeringId).companyId
        if (res.data.insidePlan.engineeringId) {
          this.selectEngineeringName({ id: res.data.insidePlan.engineeringId, companyId: companyId });
          queryControlMession({ engineeringId: res.data.insidePlan.engineeringId }).then(res2 => {
            if (res2.code == 1001) {
              if (res2.data.controlStatus == 1) {
                this.$message.warning(`该项目已被管控,${res2.data.controlStatusHint}`);
                this.controlForm = res2.data.controlStatusHint
              }
            }
          })

        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.projectName = "";
      this.tableParam.bindingStatus = "";
      (this.startTimDateEndTimDate = [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")]), this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>